import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f56ec1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "โครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่อนุมัติ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบเหลือจ่ายที่ได้รับ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["data-bs-content"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }, null, -1))
const _hoisted_8 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_ProjectOffcanvasComponent = _resolveComponent("ProjectOffcanvasComponent")!
  const _component_ProjectAttachmentModalComponent = _resolveComponent("ProjectAttachmentModalComponent")!
  const _component_ProjectAttachmentFormComponent = _resolveComponent("ProjectAttachmentFormComponent")!
  const _component_ProjectImageModalComponent = _resolveComponent("ProjectImageModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("เพิ่มโครงการ " + _toDisplayString(_ctx.province?.name !== 'กรุงเทพมหานคร' ? 'จ.': '') + _toDisplayString(_ctx.province?.name), 1)
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "row-hover",
                    onClick: ($event: any) => (_ctx.selectedClick(project.id))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", {
                      class: "column-name text-truncate",
                      "data-bs-toggle": "popover-project",
                      "data-bs-content": project.name
                    }, [
                      _hoisted_7,
                      _createTextVNode(_toDisplayString(project.name), 1)
                    ], 8, _hoisted_6),
                    _createElementVNode("td", null, _toDisplayString(project.projectApprovement ? _ctx.thaiDate(project.projectApprovement.approvedDate) : '-'), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(Number(project.projectBudgets.filter(m => m.id === 2).reduce((total, m) => total + (m.amount ? m.amount : 0), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1),
                    _withDirectives(_createElementVNode("td", null, null, 512), [
                      [_directive_dompurify_html, _ctx.status(project.isCanceled, project.projectStatus.name, project.projectStatus.color)]
                    ])
                  ], 8, _hoisted_5))
                }), 128))
              ])
            ], 512)
          ]))
    ]),
    _createVNode(_component_ProjectOffcanvasComponent, {
      ref: "projectOffcanvas",
      "project-id": _ctx.selectedProjectId,
      onAttachment: _ctx.attachmentClick,
      onImage: _ctx.imageClick
    }, null, 8, ["project-id", "onAttachment", "onImage"]),
    _createVNode(_component_ProjectAttachmentModalComponent, {
      ref: "projectAttachmentModel",
      "project-id": _ctx.selectedProjectId,
      onUpload: _ctx.uploadClick,
      onHidden: _ctx.attachmentClose
    }, null, 8, ["project-id", "onUpload", "onHidden"]),
    _createVNode(_component_ProjectAttachmentFormComponent, {
      ref: "projectAttachmentForm",
      "project-id": _ctx.selectedProjectId,
      onHidden: _ctx.uploadClose
    }, null, 8, ["project-id", "onHidden"]),
    _createVNode(_component_ProjectImageModalComponent, {
      ref: "projectImageModal",
      "project-id": _ctx.selectedProjectId
    }, null, 8, ["project-id"])
  ], 64))
}